__turbopack_context__.v({
  "closeIcon": "AppMandatePopup-module-scss-module__HzaHya__closeIcon",
  "content": "AppMandatePopup-module-scss-module__HzaHya__content",
  "innerContent": "AppMandatePopup-module-scss-module__HzaHya__innerContent",
  "main": "AppMandatePopup-module-scss-module__HzaHya__main",
});
